/* eslint-disable */
import Model, { Indexable } from "./Model";
import { Company, Brand, Product } from ".";

export default class ComparisonGroup extends Model {
  static type = "comparisonGroups";

  name!: string;
  companies!: Company[];
  brands!: Brand[];
  products!: Product[];

  constructor(data: any, included = []) {
    super(data, included);
  }

  get elementsCount(): number {
    return this.companies.length + this.brands.length + this.products.length;
  }

  get entries(): {
    [key: string]: Set<number>;
  } {
    const entries: {
      [key: string]: Set<number>;
    } = {};

    const types = ["companies", "brands", "products"];

    types.forEach((type) => {
      entries[type] = new Set<number>();
      (this as Indexable)[type].forEach((entry: Company | Brand | Product) => {
        entries[type].add(entry.id);
      });
    });

    return entries;
  }

  get type(): string {
    return ComparisonGroup.type;
  }

  isEmpty() {
    return this.elementsCount == 0;
  }

  hasEntry(value: Company | Brand | Product) {
    return this.entries[value.type].has(value.id);
  }

  addEntry(value: Company | Brand | Product) {
    (this as Indexable)[value.type].push(value);
  }

  removeEntry(value: Company | Brand | Product) {
    const index = (this as Indexable)[value.type].findIndex(
      (element: Company | Brand | Product) => {
        return element.id == value.id;
      }
    );

    if (index >= 0) {
      (this as Indexable)[value.type].splice(index, 1);
    }
  }
}
